function baseStyle(props) {
  var _props$color;

  return {
    bg: (_props$color = props.color) != null ? _props$color : "blackAlpha.500"
  };
}

export default {
  baseStyle
};
//# sourceMappingURL=overlay.js.map